module.exports = __webpack_public_path__ + "static/media/create-organization-page.dde2f4cc.png";